import { render, staticRenderFns } from "./BudgetBidding.vue?vue&type=template&id=02336162"
import script from "./BudgetBidding.vue?vue&type=script&lang=js"
export * from "./BudgetBidding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports